var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "1100", persistent: "" },
      model: {
        value: _vm.captureScheduleDetailsDailog,
        callback: function($$v) {
          _vm.captureScheduleDetailsDailog = $$v
        },
        expression: "captureScheduleDetailsDailog"
      }
    },
    [
      _c(
        "v-card",
        {
          staticClass: "popup add_store_popup",
          staticStyle: { "padding-bottom": "2px" }
        },
        [
          _c("div", [
            _c(
              "h2",
              {
                staticClass: "page-title-bar",
                staticStyle: {
                  "margin-bottom": "14px !important",
                  float: "left"
                }
              },
              [
                _c("img", {
                  staticStyle: { "margin-right": "10px", width: "30px" },
                  attrs: { src: require("@/assets/img/camera.png") }
                }),
                _vm._v(_vm._s(_vm.$t("Capture Schedule Setting")) + " ")
              ]
            ),
            _c("div", { staticStyle: { float: "right" } }, [
              _vm._v(_vm._s("Timezone : " + _vm.storeTimeZone))
            ])
          ]),
          _c("div", { staticStyle: { clear: "both" } }),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-toolbar", {
                    staticStyle: { height: "50px" },
                    attrs: { flat: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "extension",
                        fn: function() {
                          return [
                            _c(
                              "v-tabs",
                              {
                                staticStyle: { "margin-top": "-135px" },
                                attrs: {
                                  "background-color": "#001e38",
                                  color: "#fff",
                                  grow: ""
                                },
                                on: { change: _vm.handleTabChange },
                                model: {
                                  value: _vm.tab,
                                  callback: function($$v) {
                                    _vm.tab = $$v
                                  },
                                  expression: "tab"
                                }
                              },
                              [
                                _c("v-tabs-slider"),
                                _c(
                                  "v-tab",
                                  {
                                    ref: "tab2",
                                    staticStyle: {
                                      "border-top-right-radius": "10px"
                                    },
                                    attrs: { href: "#tab-2nd" },
                                    on: {
                                      click: function($event) {
                                        return _vm.checkRogHasData($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("Shelf Status")))
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  }),
                  _c(
                    "v-tabs-items",
                    {
                      staticStyle: {
                        padding: "20px",
                        height: "60vh",
                        "overflow-y": "auto"
                      },
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _vm.tab === "tab-1st"
                        ? _c(
                            "v-tab-item",
                            {
                              attrs: {
                                value: "tab-1st",
                                transition: false,
                                "reverse-transition": false
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-space-between mt-4"
                                },
                                [
                                  _c("div", { staticClass: "w-100" }, [
                                    _c(
                                      "div",
                                      { staticClass: "row my-3 mx-0" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "190px",
                                              display: "inline-flex"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-menu",
                                              {
                                                attrs: {
                                                  "close-on-content-click": false,
                                                  transition:
                                                    "scale-transition",
                                                  "offset-y": "",
                                                  "min-width": "290px"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        var attrs = ref.attrs
                                                        return [
                                                          _c(
                                                            "v-text-field",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  ref:
                                                                    "startDate",
                                                                  staticClass:
                                                                    "form-input mr-3 col mandatoryv2",
                                                                  staticStyle: {
                                                                    "padding-top":
                                                                      "0px"
                                                                  },
                                                                  attrs: {
                                                                    label:
                                                                      "Start Time",
                                                                    placeholder:
                                                                      "" +
                                                                      _vm.$t(
                                                                        "Select Start Date"
                                                                      ),
                                                                    outlined:
                                                                      "",
                                                                    dense: "",
                                                                    clearable:
                                                                      "",
                                                                    "hide-details":
                                                                      "",
                                                                    readonly:
                                                                      "",
                                                                    "prepend-icon":
                                                                      "",
                                                                    "append-icon":
                                                                      "mdi-calendar-month",
                                                                    disabled:
                                                                      _vm
                                                                        .rogTableData
                                                                        .length >
                                                                      0
                                                                  },
                                                                  on: {
                                                                    "click:clear": function(
                                                                      $event
                                                                    ) {
                                                                      _vm.startDate =
                                                                        ""
                                                                    },
                                                                    "click:append": function(
                                                                      $event
                                                                    ) {
                                                                      _vm.$refs.startDate.$el
                                                                        .querySelector(
                                                                          "input"
                                                                        )
                                                                        .click()
                                                                    }
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.startDate,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.startDate = $$v
                                                                    },
                                                                    expression:
                                                                      "startDate"
                                                                  }
                                                                },
                                                                "v-text-field",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            )
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  435110812
                                                ),
                                                model: {
                                                  value: _vm.pickStartDate,
                                                  callback: function($$v) {
                                                    _vm.pickStartDate = $$v
                                                  },
                                                  expression: "pickStartDate"
                                                }
                                              },
                                              [
                                                _c("v-date-picker", {
                                                  attrs: {
                                                    "no-title": "",
                                                    min: _vm.minDate()
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      _vm.pickStartDate = false
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.startDate,
                                                    callback: function($$v) {
                                                      _vm.startDate = $$v
                                                    },
                                                    expression: "startDate"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "190px",
                                              display: "inline-flex"
                                            }
                                          },
                                          [
                                            _c("v-select", {
                                              staticClass: "ml-3",
                                              attrs: {
                                                items: _vm.hourList,
                                                outlined: "",
                                                dense: "",
                                                "hide-details": ""
                                              },
                                              model: {
                                                value: _vm.startHour,
                                                callback: function($$v) {
                                                  _vm.startHour = $$v
                                                },
                                                expression: "startHour"
                                              }
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  margin: "7px 0 0 5px"
                                                }
                                              },
                                              [_c("p", [_vm._v(":")])]
                                            ),
                                            _c("v-select", {
                                              staticClass: "ml-3",
                                              attrs: {
                                                items: _vm.minList,
                                                outlined: "",
                                                dense: "",
                                                "hide-details": ""
                                              },
                                              model: {
                                                value: _vm.startMin,
                                                callback: function($$v) {
                                                  _vm.startMin = $$v
                                                },
                                                expression: "startMin"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "row my-3 mx-0" },
                                      [
                                        _c("v-col", { attrs: { cols: "11" } }, [
                                          _c(
                                            "small",
                                            { staticClass: "textHeaings" },
                                            [_vm._v("Repeat *")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "row align-center" },
                                            [
                                              _vm._l(
                                                _vm.getWeekDaysSelectedRog,
                                                function(item, i) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: i,
                                                      staticClass: "cart-size",
                                                      class: item.selected
                                                        ? "active-day"
                                                        : "not-active-day",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.selectAssignFunctionRog(
                                                            item,
                                                            i
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("small", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item.name)
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                }
                                              ),
                                              _c("v-select", {
                                                staticClass:
                                                  "form-input mx-16 col mandatoryv2 pt-0",
                                                staticStyle: {
                                                  "max-width": "162px"
                                                },
                                                attrs: {
                                                  items:
                                                    _vm.shelfGroupIntervalList,
                                                  outlined: "",
                                                  placeholder:
                                                    "Shelf Group Interval",
                                                  dense: "",
                                                  label: "Shelf Group Interval",
                                                  "hide-details": "",
                                                  disabled:
                                                    _vm.rogTableData.length > 0
                                                },
                                                model: {
                                                  value:
                                                    _vm.shelfGroupIntervalROG,
                                                  callback: function($$v) {
                                                    _vm.shelfGroupIntervalROG = $$v
                                                  },
                                                  expression:
                                                    "shelfGroupIntervalROG"
                                                }
                                              })
                                            ],
                                            2
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "btn" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn my-3 custom-btn",
                                          attrs: {
                                            text: "",
                                            icon: "",
                                            height: "77% !important",
                                            width: "150"
                                          },
                                          on: {
                                            click: _vm.addRogCaptureDetails
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Add")))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "RogTable" },
                                [
                                  _c(
                                    "v-data-table",
                                    {
                                      staticClass: "tbl-type01 row-class",
                                      attrs: {
                                        headers: _vm.rogTableHeader,
                                        items: _vm.rogTableData,
                                        "hide-default-footer": true,
                                        "disable-pagination": "",
                                        "item-key": "srNo",
                                        "items-per-page": 20,
                                        "single-select": false,
                                        "show-select": false,
                                        height: "300px"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "item.startTime",
                                            fn: function(ref) {
                                              var item = ref.item
                                              return [
                                                item.startTime &&
                                                item.startTime.length > 0
                                                  ? _c(
                                                      "div",
                                                      _vm._l(
                                                        item.startTime,
                                                        function(time) {
                                                          return _c(
                                                            "div",
                                                            { key: time },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  time
                                                                    ? time
                                                                    : "-"
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          },
                                          {
                                            key: "item.endTime",
                                            fn: function(ref) {
                                              var item = ref.item
                                              return [
                                                _c("span", [
                                                  _vm._v(_vm._s(item.endTime))
                                                ])
                                              ]
                                            }
                                          },
                                          {
                                            key: "item.delete",
                                            fn: function(ref) {
                                              var item = ref.item
                                              return [
                                                _c(
                                                  "span",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "pointer",
                                                        attrs: { color: "red" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.deleteItem(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-close-circle"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "no-data" },
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              staticClass: "ma-0",
                                              staticStyle: {
                                                "line-height": "19px"
                                              },
                                              attrs: {
                                                dense: "",
                                                color: "#697A8A"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: { color: "#fff" }
                                                },
                                                [_vm._v("mdi-alert-outline")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("No data available")
                                                  )
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.tab === "tab-2nd"
                        ? _c(
                            "v-tab-item",
                            {
                              attrs: {
                                value: "tab-2nd",
                                transition: false,
                                "reverse-transition": false
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-space-between mt-4"
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      { staticClass: "row my-3 mx-0" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "190px",
                                              display: "inline-flex"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-menu",
                                              {
                                                attrs: {
                                                  "close-on-content-click": false,
                                                  transition:
                                                    "scale-transition",
                                                  "offset-y": "",
                                                  "min-width": "290px"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        var attrs = ref.attrs
                                                        return [
                                                          _c(
                                                            "v-text-field",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  ref:
                                                                    "startDate1",
                                                                  staticClass:
                                                                    "form-input mr-3 col mandatoryv2",
                                                                  staticStyle: {
                                                                    "padding-top":
                                                                      "0px"
                                                                  },
                                                                  attrs: {
                                                                    label:
                                                                      "Start Time",
                                                                    placeholder:
                                                                      "" +
                                                                      _vm.$t(
                                                                        "Select Start Date"
                                                                      ),
                                                                    outlined:
                                                                      "",
                                                                    dense: "",
                                                                    clearable:
                                                                      "",
                                                                    "hide-details":
                                                                      "",
                                                                    readonly:
                                                                      "",
                                                                    "prepend-icon":
                                                                      "",
                                                                    "append-icon":
                                                                      "mdi-calendar-month",
                                                                    disabled:
                                                                      _vm
                                                                        .shelfStatusTableData
                                                                        .length >=
                                                                      1
                                                                  },
                                                                  on: {
                                                                    "click:clear": function(
                                                                      $event
                                                                    ) {
                                                                      _vm.startDate1 =
                                                                        ""
                                                                    },
                                                                    "click:append": function(
                                                                      $event
                                                                    ) {
                                                                      _vm.$refs.startDate1.$el
                                                                        .querySelector(
                                                                          "input"
                                                                        )
                                                                        .click()
                                                                    }
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.startDate1,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.startDate1 = $$v
                                                                    },
                                                                    expression:
                                                                      "startDate1"
                                                                  }
                                                                },
                                                                "v-text-field",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            )
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  2648778266
                                                ),
                                                model: {
                                                  value: _vm.pickStartDate1,
                                                  callback: function($$v) {
                                                    _vm.pickStartDate1 = $$v
                                                  },
                                                  expression: "pickStartDate1"
                                                }
                                              },
                                              [
                                                _c("v-date-picker", {
                                                  attrs: {
                                                    "no-title": "",
                                                    min: _vm.minDate()
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      _vm.pickStartDate1 = false
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.startDate1,
                                                    callback: function($$v) {
                                                      _vm.startDate1 = $$v
                                                    },
                                                    expression: "startDate1"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "190px",
                                              display: "inline-flex"
                                            }
                                          },
                                          [
                                            _c("v-select", {
                                              staticClass: "ml-3",
                                              attrs: {
                                                items: _vm.hourList,
                                                outlined: "",
                                                dense: "",
                                                "hide-details": ""
                                              },
                                              model: {
                                                value: _vm.startHour1,
                                                callback: function($$v) {
                                                  _vm.startHour1 = $$v
                                                },
                                                expression: "startHour1"
                                              }
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  margin: "7px 0 0 5px"
                                                }
                                              },
                                              [_c("p", [_vm._v(":")])]
                                            ),
                                            _c("v-select", {
                                              staticClass: "ml-3",
                                              attrs: {
                                                items: _vm.minList,
                                                outlined: "",
                                                dense: "",
                                                "hide-details": ""
                                              },
                                              model: {
                                                value: _vm.startMin1,
                                                callback: function($$v) {
                                                  _vm.startMin1 = $$v
                                                },
                                                expression: "startMin1"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              margin: "7px 0 0 5px"
                                            }
                                          },
                                          [_c("p", [_vm._v("~")])]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "190px",
                                              display: "inline-flex"
                                            }
                                          },
                                          [
                                            _c("v-select", {
                                              staticClass: "ml-3",
                                              attrs: {
                                                items: _vm.hourList,
                                                outlined: "",
                                                dense: "",
                                                "hide-details": ""
                                              },
                                              model: {
                                                value: _vm.endHour1,
                                                callback: function($$v) {
                                                  _vm.endHour1 = $$v
                                                },
                                                expression: "endHour1"
                                              }
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  margin: "7px 0 0 5px"
                                                }
                                              },
                                              [_c("p", [_vm._v(":")])]
                                            ),
                                            _c("v-select", {
                                              staticClass: "ml-3",
                                              attrs: {
                                                items: _vm.minList,
                                                outlined: "",
                                                dense: "",
                                                "hide-details": ""
                                              },
                                              model: {
                                                value: _vm.endMin1,
                                                callback: function($$v) {
                                                  _vm.endMin1 = $$v
                                                },
                                                expression: "endMin1"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "90px",
                                              display: "inline-flex"
                                            }
                                          },
                                          [
                                            _c("v-select", {
                                              staticClass:
                                                "form-input ml-3 col mandatoryv2 pt-0 w-25",
                                              attrs: {
                                                items: _vm.intervalList,
                                                outlined: "",
                                                placeholder: "Select Interval",
                                                dense: "",
                                                label: "Interval",
                                                "hide-details": ""
                                              },
                                              model: {
                                                value: _vm.selectedInterval,
                                                callback: function($$v) {
                                                  _vm.selectedInterval = $$v
                                                },
                                                expression: "selectedInterval"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "row my-3 mx-0" },
                                      [
                                        _c("v-col", { attrs: { cols: "11" } }, [
                                          _c(
                                            "small",
                                            { staticClass: "textHeaings" },
                                            [_vm._v("Repeat *")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "row align-center" },
                                            [
                                              _vm._l(
                                                _vm.getWeekDaysSelected,
                                                function(item, i) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: i,
                                                      staticClass: "cart-size",
                                                      class: item.selected
                                                        ? "active-day"
                                                        : "not-active-day",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.selectAssignFunction(
                                                            item,
                                                            i
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("small", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item.name)
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                }
                                              ),
                                              _c("v-select", {
                                                staticClass:
                                                  "form-input mx-16 col mandatoryv2 pt-0",
                                                staticStyle: {
                                                  "max-width": "162px"
                                                },
                                                attrs: {
                                                  items:
                                                    _vm.shelfGroupIntervalList,
                                                  outlined: "",
                                                  placeholder:
                                                    "Shelf Group Interval",
                                                  dense: "",
                                                  label: "Shelf Group Interval",
                                                  "hide-details": "",
                                                  disabled:
                                                    _vm.shelfStatusTableData
                                                      .length > 0
                                                },
                                                model: {
                                                  value:
                                                    _vm.shelfGroupIntervalStatus,
                                                  callback: function($$v) {
                                                    _vm.shelfGroupIntervalStatus = $$v
                                                  },
                                                  expression:
                                                    "shelfGroupIntervalStatus"
                                                }
                                              })
                                            ],
                                            2
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "btn" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn my-3 custom-btn",
                                          attrs: {
                                            text: "",
                                            icon: "",
                                            height: "77% !important",
                                            width: "150",
                                            disabled: _vm.isDisable
                                          },
                                          on: {
                                            click: _vm.addShelfStatusDetails
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Add")))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "RogTable" },
                                [
                                  _c(
                                    "v-data-table",
                                    {
                                      staticClass: "tbl-type01 row-class",
                                      attrs: {
                                        headers: _vm.shelfStatusTableHeader,
                                        items: _vm.shelfStatusTableData,
                                        "hide-default-footer": true,
                                        "disable-pagination": "",
                                        "item-key": "srNo",
                                        "items-per-page": 20,
                                        "single-select": false,
                                        "show-select": false,
                                        height: "300px"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "item.time",
                                            fn: function(ref) {
                                              var item = ref.item
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "mb-1",
                                                    staticStyle: {
                                                      display: "grid"
                                                    }
                                                  },
                                                  _vm._l(item.time, function(
                                                    time,
                                                    index
                                                  ) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        key:
                                                          time.startTime +
                                                          "-" +
                                                          time.endTime +
                                                          "-" +
                                                          index
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              time.startTime
                                                            ) +
                                                            " ~ " +
                                                            _vm._s(time.endTime)
                                                        )
                                                      ]
                                                    )
                                                  }),
                                                  0
                                                )
                                              ]
                                            }
                                          },
                                          {
                                            key: "item.interval",
                                            fn: function(ref) {
                                              var item = ref.item
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "mb-1",
                                                    staticStyle: {
                                                      display: "grid"
                                                    }
                                                  },
                                                  _vm._l(
                                                    item.interval,
                                                    function(time, index) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key:
                                                            time.startTime +
                                                            "-" +
                                                            time.endTime +
                                                            "-" +
                                                            index
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(time) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            }
                                          },
                                          {
                                            key: "item.delete",
                                            fn: function(ref) {
                                              var item = ref.item
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "mb-1",
                                                    staticStyle: {
                                                      display: "grid"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "pointer",
                                                            attrs: {
                                                              color: "red"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.deleteShelfItem(
                                                                  item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-close-circle"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "no-data" },
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              staticClass: "ma-0",
                                              staticStyle: {
                                                "line-height": "19px"
                                              },
                                              attrs: {
                                                dense: "",
                                                color: "#697A8A"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: { color: "#fff" }
                                                },
                                                [_vm._v("mdi-alert-outline")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("No data available")
                                                  )
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass:
                "d-flex position-relative justify-center pb-2 mr-2 mt-0"
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn",
                  attrs: { text: "", icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.saveConfiguration()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Save")))]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "btn ml-2",
                  attrs: { text: "", icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.closeModal()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "400", persistent: "" },
          model: {
            value: _vm.dialogConfirm,
            callback: function($$v) {
              _vm.dialogConfirm = $$v
            },
            expression: "dialogConfirm"
          }
        },
        [
          _c(
            "v-card",
            {
              staticClass: "popup add_store_popup",
              attrs: { align: "center", justify: "center" }
            },
            [
              _c(
                "v-row",
                [
                  _c("v-col", [
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.confirmMessageText) }
                    })
                  ])
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.moveTap("Yes")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Yes")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.moveTap("No")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("No")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "400", persistent: "" },
          model: {
            value: _vm.sortedConfirm,
            callback: function($$v) {
              _vm.sortedConfirm = $$v
            },
            expression: "sortedConfirm"
          }
        },
        [
          _c(
            "v-card",
            {
              staticClass: "popup add_store_popup",
              attrs: { align: "center", justify: "center" }
            },
            [
              _c(
                "v-row",
                [
                  _c("v-col", [
                    _c("span", [
                      _vm._v(
                        "The given dates are not sorted. Do you want to sort the date?"
                      )
                    ])
                  ])
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.sort("Yes")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Yes")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.sort("No")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("No")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }